import { writable } from "svelte/store";

export let mainUrl = writable({
  url: "/",
});

export let tempUser = writable(null);

export let refreshLicenses = writable(false);

export let openSlackUrlStore = writable("");
